<template>
  <div class="py-4 px-4">
    <!-- Vista dinámica -->
    <component :is="viewMap[currentView]" @changeView="changeView" />
  </div>
</template>

<script>
import ServicioListado from "../services/List.vue";
import ServicioCalendario from "../services/Services.vue";
import ServicioNuevo from "../services/Nuevo.vue";

export default {
  name: "ServicioController",
  components: {
    ServicioListado,
    ServicioCalendario,
    ServicioNuevo,
  },
  data() {
    return {
      currentView: "listado",
      viewMap: {
        listado: "ServicioListado",
        calendario: "ServicioCalendario",
        nuevo: "ServicioNuevo",
      },
    };
  },
  methods: {
    changeView(vista) {        
      this.currentView = vista
    }
  }
};
</script>
